import { useState } from "react";
import { eDate, sDate } from "../../apollo";
import refresh from "../../assets/icon/refresh.png";
import { ko } from "date-fns/esm/locale";
import searchdate from "../../assets/icon/searchdate.png";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import exit from "../../assets/icon/exit.png";
import {
  ICrLinkServiceInput,
  ICrLinkServiceMutation,
  useCrLinkService,
} from "../../hooks/useCrLinkService";

import { Modal } from "@mui/material";
import { FormError2 } from "../form-error";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";

export interface ComponentTabService {
  dataList?: any[];
  DataCallback?: () => void;
}

export const ComponentTabService: React.FC<ComponentTabService> = ({
  dataList = [],
  DataCallback,
}) => {
  const [sopen, setServiceOpen] = useState(false);
  const refetchHandler = () => {
    window.location.href = "/service";
  };

  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    setFocus,
  } = useForm<ICrLinkServiceInput>({ mode: "all" });

  const onComplete = (data: ICrLinkServiceMutation) => {
    const {
      crLinkService: { ok, err },
    } = data;
    if (ok) {
      window.location.href = `/service`;
    } else {
      alert(err);
    }
  };

  const [crLinkService, { loading }] = useCrLinkService(onComplete);
  const onSubmit = () => {
    if (!loading) {
      const {
        name,
        minAmount,
        address,
        operationFrom,
        operationTo,
        isActive,
        useDeliveryFee,
      } = getValues();
      const crLinkServiceInput: ICrLinkServiceInput = {
        name,
        address,
        operationFrom,
        operationTo,
        minAmount: minAmount ? +minAmount : 0,
        isActive: isActive === undefined ? true : isActive,
        useDeliveryFee: useDeliveryFee === undefined ? true : useDeliveryFee,
      };
      crLinkService({ variables: { input: crLinkServiceInput } });
      setServiceOpen(false);
    }
  };

  const handlePostCode = (data: any) => {
    let fullAddress = data.address;
    let extraAddress = "";
    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      setValue(`address`, fullAddress);
      setFocus(`address`);
    }
  };

  const scriptUrl =
    "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
  const open = useDaumPostcodePopup(scriptUrl);
  const handlerClick = () => {
    open({ onComplete: handlePostCode });
  };

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex flex-wrap">
        <button
          className="py-3 px-4 relative"
          onClick={() => {
            refetchHandler();
          }}
        >
          <img src={refresh} alt="새로고침" className="w-[30px] h-[30px]" />
        </button>
      </div>
      <div className="flex flex-wrap space-x-2"></div>
      <div className="flex flex-wrap justify-end pr-8">
        <button
          className="bg-transparent bg-[#8b8c8c] w-[104px] h-[30px] py-[7px] text-xs font-bold text-center rounded-lg my-[13px] text-white"
          onClick={() => setServiceOpen(true)}
        >
          서비스 생성
        </button>
      </div>
      <Modal
        open={sopen}
        onClose={() => {
          setServiceOpen(false);
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="max-w-[480px] w-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#F9F8F9] rounded-lg">
            <div className="text-center py-2 h-10 text-white font-bold bg-[#3D3E49] rounded-t-lg  ">
              <div className="flex flex-wrap justify-between">
                <p className="flex-1 ml-[24px] font-bold text-base">
                  서비스지역 생성
                </p>
                <img
                  src={exit}
                  alt="닫기"
                  className="w-6 mr-2 cursor-pointer"
                  onClick={() => setServiceOpen(false)}
                ></img>
              </div>
            </div>
            <div className="px-10 py-10">
              <div className="space-y-5">
                <div className="space-y-3">
                  <p className="font-bold text-[#8B8C8C] text-sm">
                    서비스지역 이름
                  </p>
                  <input
                    {...register("name", {
                      required: `서비스이름을 입력해주세요`,
                    })}
                    type="text"
                    className="w-full border-[#F0F0F4] rounded-lg py-1 px-4 h-10"
                  ></input>
                  {errors.name?.message && (
                    <FormError2 errorMessage={errors.name.message} />
                  )}
                </div>
                <div className="space-y-2">
                  <p className="font-bold text-[#8B8C8C] text-sm">
                    <span className="pr-4">주소</span>
                    <button
                      className="bg-white py-1 px-4 border border-btnDarkLine rounded-lg text-btn text-grayFont"
                      type="button"
                      onClick={handlerClick}
                    >
                      우편번호찾기
                    </button>
                  </p>
                  <input
                    {...register("address", {
                      required: `주소를 입력해주세요`,
                    })}
                    type="text"
                    className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                  />
                  {errors.address?.message && (
                    <FormError2 errorMessage={errors.address.message} />
                  )}
                </div>
                <div className="space-y-2">
                  <p className="font-bold text-[#8B8C8C] text-sm">
                    <span className="pr-4">운영시간</span>
                  </p>
                  <div className="flex flex-wrap items-center">
                    <input
                      {...register("operationFrom", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                    <div className="w-[24px] text-center">~</div>
                    <input
                      {...register("operationTo", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                  </div>
                  {(errors.operationFrom?.message ||
                    errors.operationTo?.message) && (
                    <FormError2
                      errorMessage={
                        errors.operationFrom?.message ||
                        errors.operationTo?.message ||
                        ""
                      }
                    />
                  )}
                </div>
                <div className="space-y-2">
                  <p className="font-bold text-[#8B8C8C] text-sm">운영</p>
                  <div className="flex flex-wrap items-center">
                    <div className="flex items-center w-1/2 gap-x-4">
                      <input
                        type="radio"
                        name="isActive"
                        value="false"
                        className="w-4 h-4"
                        onChange={() => {
                          setValue("isActive", false);
                        }}
                      />
                      <p className="text-md">중단</p>
                    </div>
                    <div className="flex items-center w-1/2 gap-x-4">
                      <input
                        type="radio"
                        name="isActive"
                        value="true"
                        defaultChecked={true}
                        className="w-4 h-4"
                        onChange={() => {
                          setValue("isActive", true);
                        }}
                      />
                      <p className="text-md">운영</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-2">
                  <p className="font-bold text-[#8B8C8C] text-sm">배달비</p>
                  <div className="flex flex-wrap items-center">
                    <div className="flex items-center w-1/2 gap-x-4">
                      <input
                        type="radio"
                        name="useDeliveryFee"
                        value="false"
                        className="w-4 h-4"
                        onChange={() => {
                          setValue("useDeliveryFee", false);
                        }}
                      />
                      <p className="text-md">비적용</p>
                    </div>
                    <div className="flex items-center w-1/2 gap-x-4">
                      <input
                        type="radio"
                        name="useDeliveryFee"
                        value="true"
                        defaultChecked={true}
                        className="w-4 h-4"
                        onChange={() => {
                          setValue("useDeliveryFee", true);
                        }}
                      />
                      <p className="text-md">적용</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="w-full h-14 bg-[#F0F0F4] rounded-b-lg"
            >
              {loading ? "Loading..." : "확인"}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
